import { POSOrders } from './POSOrders';
export default POSOrders;